import React, { useContext } from 'react';
import { TranslateUrlsContext } from 'gatsby-plugin-translate-urls';

export default function withTranslateUrls(Component) {
  return function WrapperComponent(props) {
    const translateUrlsContext = useContext(TranslateUrlsContext);
    return <Component {...props} translateUrlsContext={translateUrlsContext} />;
  };
}
